var map = {
	"./sms-settings-de.html": 1966,
	"./sms-settings-en.html": 1967,
	"./sms-settings-es.html": 1968,
	"./sms-settings-fr.html": 1969,
	"./sms-settings-ja.html": 1970,
	"./sms-settings-pt.html": 1971,
	"./sms-settings-zh.html": 1972
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1965;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sms-services/help/sms-settings ^\.\/sms\-settings\-.*\.html$
// module id = 1965
// module chunks = 0